import React from 'react'
import "./App.css"
function Footer() {
    return (
        <div>
            <div className="footer">Made with💚 in RNC(Ranchi City) </div>
        </div>
    )
}

export default Footer
